import { formatRelative } from 'date-fns';
import { Timestamp } from 'firebase/firestore';

export class NtaNotification {
	notificationId?: string;

	userId: string;

	title: string;

	message: string;

	read?: boolean;

	link: string;

	dialog?: string;

	createdAt?: Date;

	since?: string;

	facilityId?: string;

	queryParams: Record<string, string> = {};

	type: string;

	constructor(partial: Partial<NtaNotification>) {
		Object.assign(this, partial);

		this.queryParams = { ...partial.queryParams ?? {} };
		if (partial.facilityId && !this.queryParams.facilityId) {
			this.queryParams.facilityId = partial.facilityId;
		}

		if (partial.createdAt instanceof Timestamp) {
			this.createdAt = partial.createdAt.toDate();
		}

		if (this.createdAt) {
			this.since = formatRelative(this.createdAt, new Date());
		}
	}

	/**
	 * Router command array from `link` (e.g. `simplimds/patients/id` -> `['/simplimds', 'patients', 'id']`).
	 */
	linkRouterCommands(): string[] {
		if (!this.link) return [];

		const parts = this.link.replace(/^\//, '').split('/').filter((part) => part);
		if (!parts.length) return [];

		return [`/${parts[0]}`, ...parts.slice(1)];
	}
}
